// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/modern/" + (chunkId === 460 ? "sharing" : chunkId) + "." + {"128":"adc634fd","460":"547bce60"}[chunkId] + ".js";
};